import React from "react";
import Radio from "../shared/Radio";

const PlanRadio = ({ value, checked }) => {
  const onChange = () => {
    const url = new URL(window.location);
    url.searchParams.set("subscription", value);
    window.location.href = url.toString();
  };

  return (
    <Radio
      name="subscription"
      value={value}
      checked={checked}
      onChange={onChange}
    />
  );
};

export default PlanRadio;
